import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./TransmissionProductOutlet.css"

export default function TransmissionProductOutlet() {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add the "show" class after the component mounts to trigger the slide-in effect
    setIsVisible(true);
  }, []);


  return (
    <div className={`TransmissionProductOutlet justify-content-center ${isVisible ? "show" : ""}`} >
      <Outlet />

    </div>
  );
}
